var BASWebServices;
(function (BASWebServices) {
    var ConfigService = (function () {
        function ConfigService($location) {
            this.$location = $location;
            this.showNavBar = true;
        }
        ConfigService.IS_SET = function () {
            return ConfigService.IS_SET_BOOLEAN;
        };
        ConfigService.SET_IS_SET = function (isSet) {
            ConfigService.IS_SET_BOOLEAN = isSet;
        };
        ConfigService.GET_BASE_URL_SERVER = function () {
            return ConfigService.BASE_URL_SERVER;
        };
        ConfigService.GET_BAS_WEBMAUS_SERVICE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.BAS_WEBMAUS_SERVICE_URL;
        };
        ConfigService.GET_BAS_WEBSERVICES_CMDI_URL_REPO = function () {
            return ConfigService.BAS_WEBSERVICES_CMDI_URL_REPO;
        };
        ConfigService.GET_BAS_WEBSERVICES_CMDI_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.BAS_WEBSERVICES_CMDI_URL;
        };
        ConfigService.GET_URL_ZIP_FILE_MULTIPLE = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.URL_ZIP_FILE_MULTIPLE;
        };
        ConfigService.CONTAINS_BAD_CHARACTER = function (name) {
            var validName = /^[a-zA-Z0-9_\.-]+$/.test(name);
            return !validName;
        };
        ConfigService.GET_SUPPORTED_SOUND_FILES = function () {
            return ConfigService.SUPPORTED_SOUND_FILES;
        };
        ConfigService.GET_SUPPORTED_ANNOTATION_FILES = function () {
            return ConfigService.SUPPORTED_ANNOTATION_FILES;
        };
        ConfigService.GET_GET_INVENTAR_SERVICE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.GET_INVENTAR_SERVICE_URL;
        };
        ConfigService.GET_VERSION_SERVICE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.VERSION_SERVICE_URL;
        };
        ConfigService.GET_FAQ_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.FAQ_URL;
        };
        ConfigService.GET_HINT_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.HINT_URL;
        };
        ConfigService.GET_MAINTENANCE_MESSAGE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.MAINTENANCE_MESSAGE_URL;
        };
        ConfigService.GET_URL_UPLOAD_FILE = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.URL_UPLOAD_FILE;
        };
        ConfigService.GET_URL_FILE_MULTI_UPLOAD = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.URL_FILE_MULTI_UPLOAD;
        };
        ConfigService.GET_URL_EMU_WEBAPP = function () {
            return this.URL_EMU_WEBAPP;
        };
        ConfigService.GET_URL_EMU_DB_CONFIG = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.URL_EMU_DB_CONFIG;
        };
        ConfigService.Factory = function ($location) {
            return new ConfigService($location);
        };
        ConfigService.GET_LANGUAGE_639_TO_WORD_MAPPING = function (languageCode) {
            var language = this.LANGUAGE_639_TO_WORD_MAPPING[languageCode];
            if (language === undefined) {
                return languageCode;
            }
            else {
                return language;
            }
        };
        ConfigService.GET_NUMBER_THREADS = function () {
            return ConfigService.NUMBER_THREADS;
        };
        ConfigService.GET_NUMBER_PARALLEL_UPLOADS = function () {
            return ConfigService.NUMBER_PARALLEL_UPLOADS;
        };
        ConfigService.GET_TERMS_OF_USAGE_ACADEMIC_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.TERMS_OF_USAGE_ACADEMIC_URL;
        };
        ConfigService.GET_TERMS_OF_USAGE_COMMERCIAL_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.TERMS_OF_USAGE_COMMERCIAL_URL;
        };
        ConfigService.GET_RANDOM_POPUP_HINT_MESSAGE = function (randomNumber) {
            var index = Math.floor(randomNumber * ConfigService.POPUP_HINT_MESSAGES.length);
            return ConfigService.POPUP_HINT_MESSAGES[index];
        };
        ConfigService.GET_KEEP_ALIVE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.KEEP_ALIVE_URL;
        };
        ConfigService.GET_KEEP_ALIVE_INTERVAL = function () {
            return ConfigService.KEEP_ALIVE_INTERVAL;
        };
        ConfigService.GET_CHECK_LOAD_INTERVAL = function () {
            return ConfigService.CHECK_LOAD_INTERVAL;
        };
        ConfigService.GET_BAS_GET_LOAD_INDICATOR = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.BAS_GET_LOAD_INDICATOR;
        };
        ConfigService.GET_GUESS_SIGNAL_FILE_FROM_ANNOTATION_FILE_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.GUESS_SIGNAL_FILE_FROM_ANNOTATION_FILE_URL;
        };
        ConfigService.GET_SESSION_ID_URL = function () {
            return ConfigService.BASE_URL_SERVER + ConfigService.SESSION_ID_URL;
        };
        ConfigService.IS_SET_BOOLEAN = false;
        ConfigService.BASE_URL_SERVER = "https://clarin.phonetik.uni-muenchen.de/BASWebServices/";
        ConfigService.BAS_WEBMAUS_SERVICE_URL = 'services/runMAUSWebLink';
        ConfigService.BAS_WEBSERVICES_CMDI_URL_REPO = "https://clarin.phonetik.uni-muenchen.de/BASRepository/Public/WebServices/BAS_Webservices.cmdi.xml";
        ConfigService.BAS_WEBSERVICES_CMDI_URL = "BAS_Webservices.cmdi.xml";
        ConfigService.URL_ZIP_FILE_MULTIPLE = "services/createZipFileLinkForMultipleXml";
        ConfigService.STANDARD_CLASS_FOR_OPTIONS = "serviceOption";
        ConfigService.SUPPORTED_SOUND_FILES = ['wav', 'nis'];
        ConfigService.SUPPORTED_ANNOTATION_FILES = ['txt', 'par'];
        ConfigService.GET_INVENTAR_SERVICE_URL = "services/runMAUSGetInventar";
        ConfigService.VERSION_SERVICE_URL = "services/runGetVersion";
        ConfigService.FAQ_URL = "services/getFAQFile";
        ConfigService.HINT_URL = "services/getHintFile";
        ConfigService.MAINTENANCE_MESSAGE_URL = "services/getMaintenanceNotification";
        ConfigService.URL_UPLOAD_FILE = 'services/uploadFile';
        ConfigService.URL_FILE_MULTI_UPLOAD = 'services/uploadFileMulti';
        ConfigService.URL_MULTI_UPLOAD_HTTP_METHOD = "POST";
        ConfigService.URL_EMU_WEBAPP = "ips-lmu.github.io/EMU-webApp/";
        ConfigService.URL_EMU_DB_CONFIG = "services/getEMUDBConfigLocation";
        ConfigService.NUMBER_THREADS = 25;
        ConfigService.NUMBER_PARALLEL_UPLOADS = 2;
        ConfigService.TERMS_OF_USAGE_ACADEMIC_URL = "services/getTermsOfUsageAcademic";
        ConfigService.TERMS_OF_USAGE_COMMERCIAL_URL = "services/getTermsOfUsageCommercial";
        ConfigService.POPUP_HINT_MESSAGES = [
            "Did you already know that we have an extensive frequently asked question (FAQ) section being found under >Help<?",
            "When only parts of the signal should be segmented and labelled, you can use our CHUNK segmentation service. More help you can find under >Help<."
        ];
        ConfigService.KEEP_ALIVE_URL = "services/sleepTest";
        ConfigService.KEEP_ALIVE_INTERVAL = 10 * 60 * 1000;
        ConfigService.CHECK_LOAD_INTERVAL = 10 * 1000;
        ConfigService.BAS_GET_LOAD_INDICATOR = 'services/getLoadIndicatorXML';
        ConfigService.GUESS_SIGNAL_FILE_FROM_ANNOTATION_FILE_URL = "services/getSignalFileFromAnnotationFile";
        ConfigService.SESSION_ID_URL = "services/getSessionId";
        ConfigService.LANGUAGE_639_TO_WORD_MAPPING = {
            "aus": "Australian Engl.",
            "ekk": "Estonian",
            "nze": "New Zealand Engl.",
            'sampa': 'SAM-PA',
            "aar": "Afar",
            "abk": "Abkhazian",
            "ace": "Achinese",
            "ach": "Acoli",
            "ada": "Adangme",
            "ady": "Adyghe; Adygei",
            "afa": "Afro-Asiatic languages",
            "afh": "Afrihili",
            "afr": "Afrikaans",
            "ain": "Ainu",
            "aka": "Akan",
            "akk": "Akkadian",
            "ale": "Aleut",
            "alg": "Algonquian languages",
            "alt": "Southern Altai",
            "amh": "Amharic",
            "ang": "English, Old (ca.450-1100)",
            "anp": "Angika",
            "apa": "Apache languages",
            "ara": "Arabic",
            "arc": "Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)",
            "arg": "Aragonese",
            "arn": "Mapudungun; Mapuche",
            "arp": "Arapaho",
            "art": "Artificial languages",
            "arw": "Arawak",
            "asm": "Assamese",
            "ast": "Asturian; Bable; Leonese; Asturleonese",
            "ath": "Athapascan languages",
            "ava": "Avaric",
            "ave": "Avestan",
            "awa": "Awadhi",
            "aym": "Aymara",
            "aze": "Azerbaijani",
            "bad": "Banda languages",
            "bai": "Bamileke languages",
            "bak": "Bashkir",
            "bal": "Baluchi",
            "bam": "Bambara",
            "ban": "Balinese",
            "bas": "Basa",
            "bat": "Baltic languages",
            "bej": "Beja; Bedawiyet",
            "bel": "Belarusian",
            "bem": "Bemba",
            "ben": "Bengali",
            "ber": "Berber languages",
            "bho": "Bhojpuri",
            "bih": "Bihari languages",
            "bik": "Bikol",
            "bin": "Bini; Edo",
            "bis": "Bislama",
            "bla": "Siksika",
            "bnt": "Bantu languages",
            "bod": "Tibetan",
            "bos": "Bosnian",
            "bra": "Braj",
            "bre": "Breton",
            "btk": "Batak languages",
            "bua": "Buriat",
            "bug": "Buginese",
            "bul": "Bulgarian",
            "byn": "Blin; Bilin",
            "cad": "Caddo",
            "cai": "Central American Indian languages",
            "car": "Galibi Carib",
            "cat": "Catalan; Valencian",
            "cau": "Caucasian languages",
            "ceb": "Cebuano",
            "cel": "Celtic languages",
            "ces": "Czech",
            "cha": "Chamorro",
            "chb": "Chibcha",
            "che": "Chechen",
            "chg": "Chagatai",
            "chk": "Chuukese",
            "chm": "Mari",
            "chn": "Chinook jargon",
            "cho": "Choctaw",
            "chp": "Chipewyan; Dene Suline",
            "chr": "Cherokee",
            "chu": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
            "chv": "Chuvash",
            "chy": "Cheyenne",
            "cmc": "Chamic languages",
            "cop": "Coptic",
            "cor": "Cornish",
            "cos": "Corsican",
            "cpe": "Creoles and pidgins, English based",
            "cpf": "Creoles and pidgins, French-based",
            "cpp": "Creoles and pidgins, Portuguese-based",
            "cre": "Cree",
            "crh": "Crimean Tatar; Crimean Turkish",
            "crp": "Creoles and pidgins",
            "csb": "Kashubian",
            "cus": "Cushitic languages",
            "cym": "Welsh",
            "dak": "Dakota",
            "dan": "Danish",
            "dar": "Dargwa",
            "day": "Land Dayak languages",
            "del": "Delaware",
            "den": "Slave (Athapascan)",
            "deu": "German",
            "dgr": "Dogrib",
            "din": "Dinka",
            "div": "Divehi; Dhivehi; Maldivian",
            "doi": "Dogri",
            "dra": "Dravidian languages",
            "dsb": "Lower Sorbian",
            "dua": "Duala",
            "dum": "Dutch, Middle (ca.1050-1350)",
            "dyu": "Dyula",
            "dzo": "Dzongkha",
            "efi": "Efik",
            "egy": "Egyptian (Ancient)",
            "eka": "Ekajuk",
            "ell": "Greek, Modern (1453-)",
            "elx": "Elamite",
            "eng": "English",
            "enm": "English, Middle (1100-1500)",
            "epo": "Esperanto",
            "est": "Estonian",
            "eus": "Basque",
            "ewe": "Ewe",
            "ewo": "Ewondo",
            "fan": "Fang",
            "fao": "Faroese",
            "fas": "Persian",
            "fas (T)": "Persian",
            "fat": "Fanti",
            "fij": "Fijian",
            "fil": "Filipino; Pilipino",
            "fin": "Finnish",
            "fiu": "Finno-Ugrian languages",
            "fon": "Fon",
            "fra": "French",
            "frm": "French, Middle (ca.1400-1600)",
            "fro": "French, Old (842-ca.1400)",
            "frr": "Northern Frisian",
            "frs": "Eastern Frisian",
            "fry": "Western Frisian",
            "ful": "Fulah",
            "fur": "Friulian",
            "gaa": "Ga",
            "gay": "Gayo",
            "gba": "Gbaya",
            "gem": "Germanic languages",
            "gez": "Geez",
            "gil": "Gilbertese",
            "gla": "Gaelic; Scottish Gaelic",
            "gle": "Irish",
            "glg": "Galician",
            "glv": "Manx",
            "gmh": "German, Middle High (ca.1050-1500)",
            "goh": "German, Old High (ca.750-1050)",
            "gon": "Gondi",
            "gor": "Gorontalo",
            "got": "Gothic",
            "grb": "Grebo",
            "grc": "Greek, Ancient (to 1453)",
            "grn": "Guarani",
            "gsw": "Swiss German; Alemannic; Alsatian",
            "guj": "Gujarati",
            "gwi": "Gwich'in",
            "hai": "Haida",
            "hat": "Haitian; Haitian Creole",
            "hau": "Hausa",
            "haw": "Hawaiian",
            "heb": "Hebrew",
            "her": "Herero",
            "hil": "Hiligaynon",
            "him": "Himachali languages; Western Pahari languages",
            "hin": "Hindi",
            "hit": "Hittite",
            "hmn": "Hmong; Mong",
            "hmo": "Hiri Motu",
            "hrv": "Croatian",
            "hsb": "Upper Sorbian",
            "hun": "Hungarian",
            "hup": "Hupa",
            "hye": "Armenian",
            "iba": "Iban",
            "ibo": "Igbo",
            "ido": "Ido",
            "iii": "Sichuan Yi; Nuosu",
            "ijo": "Ijo languages",
            "iku": "Inuktitut",
            "ile": "Interlingue; Occidental",
            "ilo": "Iloko",
            "ina": "Interlingua (International Auxiliary Language Association)",
            "inc": "Indic languages",
            "ind": "Indonesian",
            "ine": "Indo-European languages",
            "inh": "Ingush",
            "ipk": "Inupiaq",
            "ira": "Iranian languages",
            "iro": "Iroquoian languages",
            "isl": "Icelandic",
            "ita": "Italian",
            "jav": "Javanese",
            "jbo": "Lojban",
            "jpn": "Japanese",
            "jpr": "Judeo-Persian",
            "jrb": "Judeo-Arabic",
            "kaa": "Kara-Kalpak",
            "kab": "Kabyle",
            "kac": "Kachin; Jingpho",
            "kal": "Kalaallisut; Greenlandic",
            "kam": "Kamba",
            "kan": "Kannada",
            "kar": "Karen languages",
            "kas": "Kashmiri",
            "kat": "Georgian",
            "kau": "Kanuri",
            "kaw": "Kawi",
            "kaz": "Kazakh",
            "kbd": "Kabardian",
            "kha": "Khasi",
            "khi": "Khoisan languages",
            "khm": "Central Khmer",
            "kho": "Khotanese; Sakan",
            "kik": "Kikuyu; Gikuyu",
            "kin": "Kinyarwanda",
            "kir": "Kirghiz; Kyrgyz",
            "kmb": "Kimbundu",
            "kok": "Konkani",
            "kom": "Komi",
            "kon": "Kongo",
            "kor": "Korean",
            "kos": "Kosraean",
            "kpe": "Kpelle",
            "krc": "Karachay-Balkar",
            "krl": "Karelian",
            "kro": "Kru languages",
            "kru": "Kurukh",
            "kua": "Kuanyama; Kwanyama",
            "kum": "Kumyk",
            "kur": "Kurdish",
            "kut": "Kutenai",
            "lad": "Ladino",
            "lah": "Lahnda",
            "lam": "Lamba",
            "lao": "Lao",
            "lat": "Latin",
            "lav": "Latvian",
            "lez": "Lezghian",
            "lim": "Limburgan; Limburger; Limburgish",
            "lin": "Lingala",
            "lit": "Lithuanian",
            "lol": "Mongo",
            "loz": "Lozi",
            "ltz": "Luxembourgish; Letzeburgesch",
            "lua": "Luba-Lulua",
            "lub": "Luba-Katanga",
            "lug": "Ganda",
            "lui": "Luiseno",
            "lun": "Lunda",
            "luo": "Luo (Kenya and Tanzania)",
            "lus": "Lushai",
            "mad": "Madurese",
            "mag": "Magahi",
            "mah": "Marshallese",
            "mai": "Maithili",
            "mak": "Makasar",
            "mal": "Malayalam",
            "man": "Mandingo",
            "map": "Austronesian languages",
            "mar": "Marathi",
            "mas": "Masai",
            "mdf": "Moksha",
            "mdr": "Mandar",
            "men": "Mende",
            "mga": "Irish, Middle (900-1200)",
            "mic": "Mi'kmaq; Micmac",
            "min": "Minangkabau",
            "mis": "Uncoded languages",
            "mkd": "Macedonian",
            "mkh": "Mon-Khmer languages",
            "mlg": "Malagasy",
            "mlt": "Maltese",
            "mnc": "Manchu",
            "mni": "Manipuri",
            "mno": "Manobo languages",
            "moh": "Mohawk",
            "mon": "Mongolian",
            "mos": "Mossi",
            "mr": "Maori",
            "msa": "Malay",
            "mul": "Multiple languages",
            "mun": "Munda languages",
            "mus": "Creek",
            "mwl": "Mirandese",
            "mwr": "Marwari",
            "mya": "Burmese",
            "myn": "Mayan languages",
            "myv": "Erzya",
            "nah": "Nahuatl languages",
            "nai": "North American Indian languages",
            "nap": "Neapolitan",
            "nau": "Nauru",
            "nav": "Navajo; Navaho",
            "nbl": "Ndebele, South; South Ndebele",
            "nde": "Ndebele, North; North Ndebele",
            "ndo": "Ndonga",
            "nds": "Low German; Low Saxon; German, Low; Saxon, Low",
            "nep": "Nepali",
            "new": "Nepal Bhasa; Newari",
            "nia": "Nias",
            "nic": "Niger-Kordofanian languages",
            "niu": "Niuean",
            "nld": "Dutch; Flemish",
            "nno": "Norwegian Nynorsk; Nynorsk, Norwegian",
            "nob": "Bokmål, Norwegian; Norwegian Bokmål",
            "nog": "Nogai",
            "non": "Norse, Old",
            "nor": "Norwegian",
            "nqo": "N'Ko",
            "nso": "Pedi; Sepedi; Northern Sotho",
            "nub": "Nubian languages",
            "nwc": "Classical Newari; Old Newari; Classical Nepal Bhasa",
            "nya": "Chichewa; Chewa; Nyanja",
            "nym": "Nyamwezi",
            "nyn": "Nyankole",
            "nyo": "Nyoro",
            "nzi": "Nzima",
            "oci": "Occitan (post 1500)",
            "oji": "Ojibwa",
            "ori": "Oriya",
            "orm": "Oromo",
            "osa": "Osage",
            "oss": "Ossetian; Ossetic",
            "ota": "Turkish, Ottoman (1500-1928)",
            "oto": "Otomian languages",
            "paa": "Papuan languages",
            "pag": "Pangasinan",
            "pal": "Pahlavi",
            "pam": "Pampanga; Kapampangan",
            "pan": "Panjabi; Punjabi",
            "pap": "Papiamento",
            "pau": "Palauan",
            "peo": "Persian, Old (ca.600-400 B.C.)",
            "phi": "Philippine languages",
            "phn": "Phoenician",
            "pli": "Pali",
            "pol": "Polish",
            "pon": "Pohnpeian",
            "por": "Portuguese",
            "pra": "Prakrit languages",
            "pro": "Provençal, Old (to 1500);Occitan, Old (to 1500)",
            "pus": "Pushto; Pashto",
            "qaa-qtz": "Reserved for local use",
            "que": "Quechua",
            "raj": "Rajasthani",
            "rap": "Rapanui",
            "rar": "Rarotongan; Cook Islands Maori",
            "roa": "Romance languages",
            "roh": "Romansh",
            "rom": "Romany",
            "ron": "Romanian; Moldavian",
            "run": "Rundi",
            "rup": "Aromanian; Arumanian; Macedo-Romanian",
            "rus": "Russian",
            "sad": "Sandawe",
            "sag": "Sango",
            "sah": "Yakut",
            "sai": "South American Indian languages",
            "sal": "Salishan languages",
            "sam": "Samaritan Aramaic",
            "san": "Sanskrit",
            "sas": "Sasak",
            "sat": "Santali",
            "scn": "Sicilian",
            "sco": "Scots",
            "sel": "Selkup",
            "sem": "Semitic languages",
            "sga": "Irish, Old (to 900)",
            "sgn": "Sign Languages",
            "shn": "Shan",
            "sid": "Sidamo",
            "sin": "Sinhala; Sinhalese",
            "sio": "Siouan languages",
            "sit": "Sino-Tibetan languages",
            "sla": "Slavic languages",
            "slk": "Slovak",
            "slv": "Slovenian",
            "sma": "Southern Sami",
            "sme": "Northern Sami",
            "smi": "Sami languages",
            "smj": "Lule Sami",
            "smn": "Inari Sami",
            "smo": "Samoan",
            "sms": "Skolt Sami",
            "sna": "Shona",
            "snd": "Sindhi",
            "snk": "Soninke",
            "sog": "Sogdian",
            "som": "Somali",
            "son": "Songhai languages",
            "sot": "Sotho, Southern",
            "spa": "Spanish; Castilian",
            "sqi": "Albanian",
            "srd": "Sardinian",
            "srn": "Sranan Tongo",
            "srp": "Serbian",
            "srr": "Serer",
            "ssa": "Nilo-Saharan languages",
            "ssw": "Swati",
            "suk": "Sukuma",
            "sun": "Sundanese",
            "sus": "Susu",
            "sux": "Sumerian",
            "swa": "Swahili",
            "swe": "Swedish",
            "syc": "Classical Syriac",
            "syr": "Syriac",
            "tah": "Tahitian",
            "tai": "Tai languages",
            "tam": "Tamil",
            "tat": "Tatar",
            "tel": "Telugu",
            "tem": "Timne",
            "ter": "Tereno",
            "tet": "Tetum",
            "tgk": "Tajik",
            "tgl": "Tagalog",
            "tha": "Thai",
            "tig": "Tigre",
            "tir": "Tigrinya",
            "tiv": "Tiv",
            "tkl": "Tokelau",
            "tlh": "Klingon; tlhIngan-Hol",
            "tli": "Tlingit",
            "tmh": "Tamashek",
            "tog": "Tonga (Nyasa)",
            "ton": "Tonga (Tonga Islands)",
            "tpi": "Tok Pisin",
            "tsi": "Tsimshian",
            "tsn": "Tswana",
            "tso": "Tsonga",
            "tuk": "Turkmen",
            "tum": "Tumbuka",
            "tup": "Tupi languages",
            "tur": "Turkish",
            "tut": "Altaic languages",
            "tvl": "Tuvalu",
            "twi": "Twi",
            "tyv": "Tuvinian",
            "udm": "Udmurt",
            "uga": "Ugaritic",
            "uig": "Uighur; Uyghur",
            "ukr": "Ukrainian",
            "umb": "Umbundu",
            "und": "Undetermined",
            "urd": "Urdu",
            "uzb": "Uzbek",
            "vai": "Vai",
            "ven": "Venda",
            "vie": "Vietnamese",
            "vol": "Volapük",
            "vot": "Votic",
            "wak": "Wakashan languages",
            "wal": "Wolaitta; Wolaytta",
            "war": "Waray",
            "was": "Washo",
            "wen": "Sorbian languages",
            "wln": "Walloon",
            "wol": "Wolof",
            "xal": "Kalmyk; Oirat",
            "xho": "Xhosa",
            "yao": "Yao",
            "yap": "Yapese",
            "yid": "Yiddish",
            "yor": "Yoruba",
            "ypk": "Yupik languages",
            "zap": "Zapotec",
            "zbl": "Blissymbols; Blissymbolics; Bliss",
            "zen": "Zenaga",
            "zgh": "Standard Moroccan Tamazight",
            "zha": "Zhuang; Chuang",
            "zho": "Chinese",
            "znd": "Zande languages",
            "zul": "Zulu",
            "zun": "Zuni",
            "zxx": "No linguistic content; Not applicable",
            "zza": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki"
        };
        return ConfigService;
    }());
    BASWebServices.ConfigService = ConfigService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ConfigService.js.map